// SimpleTooltip — غلاف مبسّط (label + children) يطابق نمط Mantine Tooltip السابق لتسريع النقل.
import { cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

export function SimpleTooltip({ label, children }: { label: ReactNode; children: ReactNode }) {
	// التلميح مرئيّ فقط — بلا aria-label على العنصر نفسه لا يسمع قارئ الشاشة شيئًا (أزرار
	// أيقونيّة كثيرة في التطبيق بلا نصّ ظاهر). نستنسخ العنصر لإضافته تلقائيًّا من نفس نصّ label
	// ما لم يكن له أصلًا aria-label/aria-labelledby.
	let trigger = children;
	if (isValidElement(children) && typeof label === 'string') {
		const el = children as ReactElement<{ 'aria-label'?: string; 'aria-labelledby'?: string }>;
		if (!el.props['aria-label'] && !el.props['aria-labelledby']) {
			trigger = cloneElement(el, { 'aria-label': label });
		}
	}
	return (
		<TooltipProvider delayDuration={200}>
			<Tooltip>
				<TooltipTrigger asChild>{trigger}</TooltipTrigger>
				<TooltipContent>{label}</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
